const adminSettingRoleStyle = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        borderRadius: '1.5%',
    },
    rightInput: {
        width: '67%',
    },
    leftTitle: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '32%',
        textAlign: 'left',
        paddingRight: '46px',
    },
    item: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '15px',
    },
    centerItem: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: '15px',
    },
    radioButton: {
        '& span': {
            fontSize: '14px',
        },
    },
};

export default adminSettingRoleStyle;
